import { render } from "./ThumbUp.vue?vue&type=template&id=797fe438&ts=true"
import script from "./ThumbUp.vue?vue&type=script&lang=ts"
export * from "./ThumbUp.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__